<template>
  <div class="card card-hover-shadow card-frame card-bordered" :class="{ 'border-primary': selected}" style="cursor: pointer; padding: 8px 0 0;" @click="$emit('view', product)">
    <div v-if="enableDelete" class="m-2 position-absolute right-0 top-0">
      <button class="btn btn-xs btn-ghost-secondary" @click.stop="$emit('deleted', product)" title="Remove from Basket"><i class="fa fa-trash-alt"></i></button>
    </div>
    <div v-if="!selected && enableSelect" class="m-2 position-absolute left-0 top-0">
      <button class="btn btn-xs btn-ghost-secondary" @click.stop="$emit('selected', product)" title="Select Item"><i class="fa fa-plus"></i></button>
    </div>
    <div v-if="selected && enableSelect" class="m-2 position-absolute left-0 top-0">
      <button class="btn btn-xs btn-ghost-secondary" @click.stop="$emit('deselected', product)" title="Deselect Item"><i class="fa fa-times"></i></button>
    </div>
    <div class="card-body text-center p-0 pb-2 overflow-hidden greyscale">
      <img :src="product.lender.imageUrl" :title="product.lender.lenderName" :alt="product.lender.lenderName" style="max-width: 110px;"/>
      <p class="card-text">{{ product.description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductCardSmall",
  
  props: {
    product: Object,
    selected: {
      type: Boolean,
      default: false
    },
    enableSelect: {
      type: Boolean,
      default: false
    },
    enableDelete: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>